module.exports = __webpack_public_path__ + "static/media/homeBannerEN.91bb507d.png";